export default __webpack_public_path__ + "static/2383-e27c96dc9a867f88aaa041b91c4b10ba.gif";